import APIService from './APIService';

export default {
  getImportacoes() {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get('importacoes/nivel-tensao')
        .then(response => {
          const { data: importacoes } = response.data;
          resolve(importacoes);
        })
        .catch(error => reject(error));
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().post('importacoes/nivel-tensao/salvar', JSON.stringify(data))
        .then(()  => resolve(true))
        .catch(() => reject(false));
    });
  },
  getAllowedFiles() {
    return APIService.apiCall().get('importacoes/nivel-tensao/arquivos-permitidos');
  },
  getLogsImportacao(id) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`importacoes/nivel-tensao/logs/${id}`)
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => reject(error));
    });
  },
  baixarLogs(id) {
    return APIService.apiCall().get(`importacoes/nivel-tensao/logs-importacao/${id}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`importacoes/nivel-tensao/logs-tecnicos/${id}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
  baixarArquivo(id) {
    return APIService.apiCall().get(`arquivos/download/${id}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
  baixarArquivoModelo(tipoImportacao) {
    return APIService.apiCall().get(`importacoes/nivel-tensao/download/arquivo-modelo/${tipoImportacao}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
}